import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import "./Admin.css";
import api, { API_ENDPOINTS } from "../config";

const AdminSubServices = () => {
  const [subServices, setSubServices] = useState([]);
  const [services, setServices] = useState([]);
  const [formData, setFormData] = useState({ name: "", description: "", parentService: "" });
  const [editingId, setEditingId] = useState(null);
  const [notification, setNotification] = useState({ type: "", message: "" });

  // Notification helper
  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => setNotification({ type: "", message: "" }), 5000);
  };

  // Fetch all sub-services
  const fetchSubServices = async () => {
    try {
      const res = await api.get(API_ENDPOINTS.GET_ALL_SUBSERVICES, { withCredentials: true });
      setSubServices(res.data.subservices);
    } catch (err) {
      console.error("Error fetching sub-services:", err);
    }
  };

  // Fetch all services for parent selection
  const fetchServices = async () => {
    try {
      const res = await api.get(API_ENDPOINTS.GET_ALL_SERVICES);
      setServices(res.data.services);
    } catch (err) {
      console.error("Error fetching services:", err);
    }
  };

  useEffect(() => {
    fetchSubServices();
    fetchServices();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.parentService) {
      return alert("Name and parent service are required");
    }

    try {
      if (editingId) {
        await api.put(API_ENDPOINTS.UPDATE_SUBSERVICE(editingId), formData);
        showNotification("success", "Sub-service updated ✅");
      } else {
        await api.post(API_ENDPOINTS.CREATE_SUBSERVICE, formData);
        showNotification("success", "Sub-service created ✅");
      }
      setFormData({ name: "", description: "", parentService: "" });
      setEditingId(null);
      fetchSubServices();
    } catch (err) {
      console.error("Error saving sub-service:", err);
      showNotification("error", "Failed to save sub-service ❌");
    }
  };

  const handleEdit = (sub) => {
    setFormData({ name: sub.name, description: sub.description, parentService: sub.parentService._id });
    setEditingId(sub._id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this sub-service?")) return;
    try {
      await api.delete(API_ENDPOINTS.DELETE_SUBSERVICE(id));
      showNotification("success", "Sub-service deleted ✅");
      fetchSubServices();
    } catch (err) {
      console.error("Error deleting sub-service:", err);
      showNotification("error", "Failed to delete sub-service ❌");
    }
  };

  return (
    <div className="admin-container">
      <Sidebar />
      <div className="container mt-5">
        {notification.message && (
          <div className={`ik-notification ${notification.type}`}>
            <span>{notification.message}</span>
            <button className="ik-close-btn" onClick={() => setNotification({ type: "", message: "" })}>✖</button>
          </div>
        )}

        <h2 className="mb-4">Manage Sub-Services</h2>

        <form onSubmit={handleSubmit} className="mb-4">
          <div className="mb-3">
            <label className="form-label">Sub-Service Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" placeholder="Enter sub-service name" required />
          </div>

          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea name="description" value={formData.description} onChange={handleChange} className="form-control" placeholder="Enter description" />
          </div>

          <div className="mb-3">
            <label className="form-label">Parent Service</label>
            <select name="parentService" value={formData.parentService} onChange={handleChange} className="form-control" required>
              <option value="">Select a service...</option>
              {services.map((s) => (
                <option key={s._id} value={s._id}>{s.servicename}</option>
              ))}
            </select>
          </div>

          <button type="submit" className="btn btn-primary">{editingId ? "Update Sub-Service" : "Add Sub-Service"}</button>
          {editingId && (
            <button type="button" className="btn btn-secondary ms-2" onClick={() => { setEditingId(null); setFormData({ name: "", description: "", parentService: "" }); }}>Cancel</button>
          )}
        </form>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Sub-Service Name</th>
              <th>Description</th>
              <th>Parent Service</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {subServices.length > 0 ? (
              subServices.map((sub) => (
                <tr key={sub._id}>
                  <td>{sub.name}</td>
                  <td>{sub.description}</td>
                  <td>{sub.parentService?.servicename}</td>
                  <td>
                    <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(sub)}>Edit</button>
                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(sub._id)}>Delete</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">No sub-services found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminSubServices;
